// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__22LIg","cell":"ColumnAccessor_cell__3sPIs","firstCellAccent":"ColumnAccessor_firstCellAccent__2W-bM"};